import Lottie from 'lottie-react';
import { Box, Flex } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { CloseIcon, UserIcon } from 'Asset/icon';
import HelpHostDone from 'Asset/animate/help-host-done.json';
import { TextBold, TextMedium, TextRegular } from 'UiKit/typography';
import { useAppSystem } from 'Store/app';

import CardRequestInfo from 'View/host-help-partner/component/card-request-info';

import styles from './styles.module.css';

const Done = ({ dataStatusHelp }) => {
  const { t } = useTranslation('host-help-partner');
  const navigate = useNavigate();
  const { key } = useLocation();
  const { onChangeAppSystem } = useAppSystem();

  const closeTarget = key !== 'default' ? -1 : '/host';

  const onClose = () => {
    navigate(closeTarget);
    onChangeAppSystem({ isHideMobileNavBar: false });
  };
  return (
    <Box className={styles['done__container']}>
      {/* Head */}
      <Box className={styles['done__section--head']}>
        <CloseIcon size="18px" onClick={onClose} className={styles['done__head--icon']} />
        <TextMedium className={styles['done__head--title']}>{t('asking_for_help.title')}</TextMedium>
      </Box>

      {/* Content */}
      <Box className={styles['done__section--content']}>
        <Lottie animationData={HelpHostDone} loop={false} />
        <Box className={styles['done__text-container']}>
          <TextBold className={styles['title__text']}>{t('operator_coming.title')}</TextBold>
          <TextRegular className={styles['description__text']}>{t('operator_coming.description')}</TextRegular>
        </Box>

        <Flex gap={'12px'} flexDirection={'column'}>
          <Box className={styles['card__container']}>
            <Flex gap={'12px'}>
              <UserIcon size="16px" color="var(--color-neutral60)" />
              <Flex flexDirection={'column'} gap={'4px'}>
                <TextRegular>Operator</TextRegular>
                <TextBold>{dataStatusHelp?.operatorName}</TextBold>
              </Flex>
            </Flex>
          </Box>

          <CardRequestInfo data={dataStatusHelp} />
        </Flex>
      </Box>
    </Box>
  );
};

export default Done;
